// This file is auto-generated by 'node ./scripts/download-iso-languages.ts'. Do not edit manually.

export const isoLanguages = [
  {
    id: "aar",
    char2Code: "aa",
    char3Code: "aar",
    name: "Afar",
  },
  {
    id: "abk",
    char2Code: "ab",
    char3Code: "abk",
    name: "Abkhazian",
  },
  {
    id: "afr",
    char2Code: "af",
    char3Code: "afr",
    name: "Afrikaans",
  },
  {
    id: "aka",
    char2Code: "ak",
    char3Code: "aka",
    name: "Akan",
  },
  {
    id: "amh",
    char2Code: "am",
    char3Code: "amh",
    name: "Amharic",
  },
  {
    id: "ara",
    char2Code: "ar",
    char3Code: "ara",
    name: "Arabic",
  },
  {
    id: "arg",
    char2Code: "an",
    char3Code: "arg",
    name: "Aragonese",
  },
  {
    id: "asm",
    char2Code: "as",
    char3Code: "asm",
    name: "Assamese",
  },
  {
    id: "ava",
    char2Code: "av",
    char3Code: "ava",
    name: "Avaric",
  },
  {
    id: "aym",
    char2Code: "ay",
    char3Code: "aym",
    name: "Aymara",
  },
  {
    id: "aze",
    char2Code: "az",
    char3Code: "aze",
    name: "Azerbaijani",
  },
  {
    id: "bak",
    char2Code: "ba",
    char3Code: "bak",
    name: "Bashkir",
  },
  {
    id: "bam",
    char2Code: "bm",
    char3Code: "bam",
    name: "Bambara",
  },
  {
    id: "bel",
    char2Code: "be",
    char3Code: "bel",
    name: "Belarusian",
  },
  {
    id: "ben",
    char2Code: "bn",
    char3Code: "ben",
    name: "Bengali",
  },
  {
    id: "bis",
    char2Code: "bi",
    char3Code: "bis",
    name: "Bislama",
  },
  {
    id: "bod",
    char2Code: "bo",
    char3Code: "bod",
    name: "Tibetan",
  },
  {
    id: "bos",
    char2Code: "bs",
    char3Code: "bos",
    name: "Bosnian",
  },
  {
    id: "bre",
    char2Code: "br",
    char3Code: "bre",
    name: "Breton",
  },
  {
    id: "bul",
    char2Code: "bg",
    char3Code: "bul",
    name: "Bulgarian",
  },
  {
    id: "cat",
    char2Code: "ca",
    char3Code: "cat",
    name: "Catalan",
  },
  {
    id: "ces",
    char2Code: "cs",
    char3Code: "ces",
    name: "Czech",
  },
  {
    id: "cha",
    char2Code: "ch",
    char3Code: "cha",
    name: "Chamorro",
  },
  {
    id: "che",
    char2Code: "ce",
    char3Code: "che",
    name: "Chechen",
  },
  {
    id: "chv",
    char2Code: "cv",
    char3Code: "chv",
    name: "Chuvash",
  },
  {
    id: "cor",
    char2Code: "kw",
    char3Code: "cor",
    name: "Cornish",
  },
  {
    id: "cos",
    char2Code: "co",
    char3Code: "cos",
    name: "Corsican",
  },
  {
    id: "cre",
    char2Code: "cr",
    char3Code: "cre",
    name: "Cree",
  },
  {
    id: "cym",
    char2Code: "cy",
    char3Code: "cym",
    name: "Welsh",
  },
  {
    id: "dan",
    char2Code: "da",
    char3Code: "dan",
    name: "Danish",
  },
  {
    id: "deu",
    char2Code: "de",
    char3Code: "deu",
    name: "German",
  },
  {
    id: "div",
    char2Code: "dv",
    char3Code: "div",
    name: "Dhivehi",
  },
  {
    id: "dzo",
    char2Code: "dz",
    char3Code: "dzo",
    name: "Dzongkha",
  },
  {
    id: "ell",
    char2Code: "el",
    char3Code: "ell",
    name: "Modern Greek (1453-)",
  },
  {
    id: "eng",
    char2Code: "en",
    char3Code: "eng",
    name: "English",
  },
  {
    id: "est",
    char2Code: "et",
    char3Code: "est",
    name: "Estonian",
  },
  {
    id: "eus",
    char2Code: "eu",
    char3Code: "eus",
    name: "Basque",
  },
  {
    id: "ewe",
    char2Code: "ee",
    char3Code: "ewe",
    name: "Ewe",
  },
  {
    id: "fao",
    char2Code: "fo",
    char3Code: "fao",
    name: "Faroese",
  },
  {
    id: "fas",
    char2Code: "fa",
    char3Code: "fas",
    name: "Persian",
  },
  {
    id: "fij",
    char2Code: "fj",
    char3Code: "fij",
    name: "Fijian",
  },
  {
    id: "fin",
    char2Code: "fi",
    char3Code: "fin",
    name: "Finnish",
  },
  {
    id: "fra",
    char2Code: "fr",
    char3Code: "fra",
    name: "French",
  },
  {
    id: "fry",
    char2Code: "fy",
    char3Code: "fry",
    name: "Western Frisian",
  },
  {
    id: "ful",
    char2Code: "ff",
    char3Code: "ful",
    name: "Fulah",
  },
  {
    id: "gla",
    char2Code: "gd",
    char3Code: "gla",
    name: "Scottish Gaelic",
  },
  {
    id: "gle",
    char2Code: "ga",
    char3Code: "gle",
    name: "Irish",
  },
  {
    id: "glg",
    char2Code: "gl",
    char3Code: "glg",
    name: "Galician",
  },
  {
    id: "glv",
    char2Code: "gv",
    char3Code: "glv",
    name: "Manx",
  },
  {
    id: "grn",
    char2Code: "gn",
    char3Code: "grn",
    name: "Guarani",
  },
  {
    id: "guj",
    char2Code: "gu",
    char3Code: "guj",
    name: "Gujarati",
  },
  {
    id: "hat",
    char2Code: "ht",
    char3Code: "hat",
    name: "Haitian",
  },
  {
    id: "hau",
    char2Code: "ha",
    char3Code: "hau",
    name: "Hausa",
  },
  {
    id: "hbs",
    char2Code: "sh",
    char3Code: "hbs",
    name: "Serbo-Croatian",
  },
  {
    id: "heb",
    char2Code: "he",
    char3Code: "heb",
    name: "Hebrew",
  },
  {
    id: "her",
    char2Code: "hz",
    char3Code: "her",
    name: "Herero",
  },
  {
    id: "hin",
    char2Code: "hi",
    char3Code: "hin",
    name: "Hindi",
  },
  {
    id: "hmo",
    char2Code: "ho",
    char3Code: "hmo",
    name: "Hiri Motu",
  },
  {
    id: "hrv",
    char2Code: "hr",
    char3Code: "hrv",
    name: "Croatian",
  },
  {
    id: "hun",
    char2Code: "hu",
    char3Code: "hun",
    name: "Hungarian",
  },
  {
    id: "hye",
    char2Code: "hy",
    char3Code: "hye",
    name: "Armenian",
  },
  {
    id: "ibo",
    char2Code: "ig",
    char3Code: "ibo",
    name: "Igbo",
  },
  {
    id: "iii",
    char2Code: "ii",
    char3Code: "iii",
    name: "Sichuan Yi",
  },
  {
    id: "iku",
    char2Code: "iu",
    char3Code: "iku",
    name: "Inuktitut",
  },
  {
    id: "ind",
    char2Code: "id",
    char3Code: "ind",
    name: "Indonesian",
  },
  {
    id: "ipk",
    char2Code: "ik",
    char3Code: "ipk",
    name: "Inupiaq",
  },
  {
    id: "isl",
    char2Code: "is",
    char3Code: "isl",
    name: "Icelandic",
  },
  {
    id: "ita",
    char2Code: "it",
    char3Code: "ita",
    name: "Italian",
  },
  {
    id: "jav",
    char2Code: "jv",
    char3Code: "jav",
    name: "Javanese",
  },
  {
    id: "jpn",
    char2Code: "ja",
    char3Code: "jpn",
    name: "Japanese",
  },
  {
    id: "kal",
    char2Code: "kl",
    char3Code: "kal",
    name: "Kalaallisut",
  },
  {
    id: "kan",
    char2Code: "kn",
    char3Code: "kan",
    name: "Kannada",
  },
  {
    id: "kas",
    char2Code: "ks",
    char3Code: "kas",
    name: "Kashmiri",
  },
  {
    id: "kat",
    char2Code: "ka",
    char3Code: "kat",
    name: "Georgian",
  },
  {
    id: "kau",
    char2Code: "kr",
    char3Code: "kau",
    name: "Kanuri",
  },
  {
    id: "kaz",
    char2Code: "kk",
    char3Code: "kaz",
    name: "Kazakh",
  },
  {
    id: "khm",
    char2Code: "km",
    char3Code: "khm",
    name: "Khmer",
  },
  {
    id: "kik",
    char2Code: "ki",
    char3Code: "kik",
    name: "Kikuyu",
  },
  {
    id: "kin",
    char2Code: "rw",
    char3Code: "kin",
    name: "Kinyarwanda",
  },
  {
    id: "kir",
    char2Code: "ky",
    char3Code: "kir",
    name: "Kirghiz",
  },
  {
    id: "kom",
    char2Code: "kv",
    char3Code: "kom",
    name: "Komi",
  },
  {
    id: "kon",
    char2Code: "kg",
    char3Code: "kon",
    name: "Kongo",
  },
  {
    id: "kor",
    char2Code: "ko",
    char3Code: "kor",
    name: "Korean",
  },
  {
    id: "kua",
    char2Code: "kj",
    char3Code: "kua",
    name: "Kuanyama",
  },
  {
    id: "kur",
    char2Code: "ku",
    char3Code: "kur",
    name: "Kurdish",
  },
  {
    id: "lao",
    char2Code: "lo",
    char3Code: "lao",
    name: "Lao",
  },
  {
    id: "lav",
    char2Code: "lv",
    char3Code: "lav",
    name: "Latvian",
  },
  {
    id: "lim",
    char2Code: "li",
    char3Code: "lim",
    name: "Limburgan",
  },
  {
    id: "lin",
    char2Code: "ln",
    char3Code: "lin",
    name: "Lingala",
  },
  {
    id: "lit",
    char2Code: "lt",
    char3Code: "lit",
    name: "Lithuanian",
  },
  {
    id: "ltz",
    char2Code: "lb",
    char3Code: "ltz",
    name: "Luxembourgish",
  },
  {
    id: "lub",
    char2Code: "lu",
    char3Code: "lub",
    name: "Luba-Katanga",
  },
  {
    id: "lug",
    char2Code: "lg",
    char3Code: "lug",
    name: "Ganda",
  },
  {
    id: "mah",
    char2Code: "mh",
    char3Code: "mah",
    name: "Marshallese",
  },
  {
    id: "mal",
    char2Code: "ml",
    char3Code: "mal",
    name: "Malayalam",
  },
  {
    id: "mar",
    char2Code: "mr",
    char3Code: "mar",
    name: "Marathi",
  },
  {
    id: "mkd",
    char2Code: "mk",
    char3Code: "mkd",
    name: "Macedonian",
  },
  {
    id: "mlg",
    char2Code: "mg",
    char3Code: "mlg",
    name: "Malagasy",
  },
  {
    id: "mlt",
    char2Code: "mt",
    char3Code: "mlt",
    name: "Maltese",
  },
  {
    id: "mon",
    char2Code: "mn",
    char3Code: "mon",
    name: "Mongolian",
  },
  {
    id: "mri",
    char2Code: "mi",
    char3Code: "mri",
    name: "Maori",
  },
  {
    id: "msa",
    char2Code: "ms",
    char3Code: "msa",
    name: "Malay (macrolanguage)",
  },
  {
    id: "mya",
    char2Code: "my",
    char3Code: "mya",
    name: "Burmese",
  },
  {
    id: "nau",
    char2Code: "na",
    char3Code: "nau",
    name: "Nauru",
  },
  {
    id: "nav",
    char2Code: "nv",
    char3Code: "nav",
    name: "Navajo",
  },
  {
    id: "nbl",
    char2Code: "nr",
    char3Code: "nbl",
    name: "South Ndebele",
  },
  {
    id: "nde",
    char2Code: "nd",
    char3Code: "nde",
    name: "North Ndebele",
  },
  {
    id: "ndo",
    char2Code: "ng",
    char3Code: "ndo",
    name: "Ndonga",
  },
  {
    id: "nep",
    char2Code: "ne",
    char3Code: "nep",
    name: "Nepali (macrolanguage)",
  },
  {
    id: "nld",
    char2Code: "nl",
    char3Code: "nld",
    name: "Dutch",
  },
  {
    id: "nno",
    char2Code: "nn",
    char3Code: "nno",
    name: "Norwegian Nynorsk",
  },
  {
    id: "nob",
    char2Code: "nb",
    char3Code: "nob",
    name: "Norwegian Bokmål",
  },
  {
    id: "nor",
    char2Code: "no",
    char3Code: "nor",
    name: "Norwegian",
  },
  {
    id: "nya",
    char2Code: "ny",
    char3Code: "nya",
    name: "Chichewa",
  },
  {
    id: "oci",
    char2Code: "oc",
    char3Code: "oci",
    name: "Occitan (post 1500)",
  },
  {
    id: "oji",
    char2Code: "oj",
    char3Code: "oji",
    name: "Ojibwa",
  },
  {
    id: "ori",
    char2Code: "or",
    char3Code: "ori",
    name: "Oriya (macrolanguage)",
  },
  {
    id: "orm",
    char2Code: "om",
    char3Code: "orm",
    name: "Oromo",
  },
  {
    id: "oss",
    char2Code: "os",
    char3Code: "oss",
    name: "Iron Ossetic",
  },
  {
    id: "pan",
    char2Code: "pa",
    char3Code: "pan",
    name: "Panjabi",
  },
  {
    id: "pol",
    char2Code: "pl",
    char3Code: "pol",
    name: "Polish",
  },
  {
    id: "por",
    char2Code: "pt",
    char3Code: "por",
    name: "Portuguese",
  },
  {
    id: "pus",
    char2Code: "ps",
    char3Code: "pus",
    name: "Pushto",
  },
  {
    id: "que",
    char2Code: "qu",
    char3Code: "que",
    name: "Quechua",
  },
  {
    id: "roh",
    char2Code: "rm",
    char3Code: "roh",
    name: "Romansh",
  },
  {
    id: "ron",
    char2Code: "ro",
    char3Code: "ron",
    name: "Romanian",
  },
  {
    id: "run",
    char2Code: "rn",
    char3Code: "run",
    name: "Rundi",
  },
  {
    id: "rus",
    char2Code: "ru",
    char3Code: "rus",
    name: "Russian",
  },
  {
    id: "sag",
    char2Code: "sg",
    char3Code: "sag",
    name: "Sango",
  },
  {
    id: "sin",
    char2Code: "si",
    char3Code: "sin",
    name: "Sinhala",
  },
  {
    id: "slk",
    char2Code: "sk",
    char3Code: "slk",
    name: "Slovak",
  },
  {
    id: "slv",
    char2Code: "sl",
    char3Code: "slv",
    name: "Slovenian",
  },
  {
    id: "sme",
    char2Code: "se",
    char3Code: "sme",
    name: "Northern Sami",
  },
  {
    id: "smo",
    char2Code: "sm",
    char3Code: "smo",
    name: "Samoan",
  },
  {
    id: "sna",
    char2Code: "sn",
    char3Code: "sna",
    name: "Shona",
  },
  {
    id: "snd",
    char2Code: "sd",
    char3Code: "snd",
    name: "Sindhi",
  },
  {
    id: "som",
    char2Code: "so",
    char3Code: "som",
    name: "Somali",
  },
  {
    id: "sot",
    char2Code: "st",
    char3Code: "sot",
    name: "Southern Sotho",
  },
  {
    id: "spa",
    char2Code: "es",
    char3Code: "spa",
    name: "Spanish",
  },
  {
    id: "sqi",
    char2Code: "sq",
    char3Code: "sqi",
    name: "Albanian",
  },
  {
    id: "srd",
    char2Code: "sc",
    char3Code: "srd",
    name: "Sardinian",
  },
  {
    id: "srp",
    char2Code: "sr",
    char3Code: "srp",
    name: "Serbian",
  },
  {
    id: "ssw",
    char2Code: "ss",
    char3Code: "ssw",
    name: "Swati",
  },
  {
    id: "sun",
    char2Code: "su",
    char3Code: "sun",
    name: "Sundanese",
  },
  {
    id: "swa",
    char2Code: "sw",
    char3Code: "swa",
    name: "Swahili (macrolanguage)",
  },
  {
    id: "swe",
    char2Code: "sv",
    char3Code: "swe",
    name: "Swedish",
  },
  {
    id: "tah",
    char2Code: "ty",
    char3Code: "tah",
    name: "Tahitian",
  },
  {
    id: "tam",
    char2Code: "ta",
    char3Code: "tam",
    name: "Tamil",
  },
  {
    id: "tat",
    char2Code: "tt",
    char3Code: "tat",
    name: "Tatar",
  },
  {
    id: "tel",
    char2Code: "te",
    char3Code: "tel",
    name: "Telugu",
  },
  {
    id: "tgk",
    char2Code: "tg",
    char3Code: "tgk",
    name: "Tajik",
  },
  {
    id: "tgl",
    char2Code: "tl",
    char3Code: "tgl",
    name: "Tagalog",
  },
  {
    id: "tha",
    char2Code: "th",
    char3Code: "tha",
    name: "Thai",
  },
  {
    id: "tir",
    char2Code: "ti",
    char3Code: "tir",
    name: "Tigrinya",
  },
  {
    id: "ton",
    char2Code: "to",
    char3Code: "ton",
    name: "Tonga (Tonga Islands)",
  },
  {
    id: "tsn",
    char2Code: "tn",
    char3Code: "tsn",
    name: "Tswana",
  },
  {
    id: "tso",
    char2Code: "ts",
    char3Code: "tso",
    name: "Tsonga",
  },
  {
    id: "tuk",
    char2Code: "tk",
    char3Code: "tuk",
    name: "Turkmen",
  },
  {
    id: "tur",
    char2Code: "tr",
    char3Code: "tur",
    name: "Turkish",
  },
  {
    id: "twi",
    char2Code: "tw",
    char3Code: "twi",
    name: "Twi",
  },
  {
    id: "uig",
    char2Code: "ug",
    char3Code: "uig",
    name: "Uighur",
  },
  {
    id: "ukr",
    char2Code: "uk",
    char3Code: "ukr",
    name: "Ukrainian",
  },
  {
    id: "urd",
    char2Code: "ur",
    char3Code: "urd",
    name: "Urdu",
  },
  {
    id: "uzb",
    char2Code: "uz",
    char3Code: "uzb",
    name: "Uzbek",
  },
  {
    id: "ven",
    char2Code: "ve",
    char3Code: "ven",
    name: "Venda",
  },
  {
    id: "vie",
    char2Code: "vi",
    char3Code: "vie",
    name: "Vietnamese",
  },
  {
    id: "wln",
    char2Code: "wa",
    char3Code: "wln",
    name: "Walloon",
  },
  {
    id: "wol",
    char2Code: "wo",
    char3Code: "wol",
    name: "Wolof",
  },
  {
    id: "xho",
    char2Code: "xh",
    char3Code: "xho",
    name: "Xhosa",
  },
  {
    id: "yid",
    char2Code: "yi",
    char3Code: "yid",
    name: "Yiddish",
  },
  {
    id: "yor",
    char2Code: "yo",
    char3Code: "yor",
    name: "Yoruba",
  },
  {
    id: "zha",
    char2Code: "za",
    char3Code: "zha",
    name: "Zhuang",
  },
  {
    id: "zho",
    char2Code: "zh",
    char3Code: "zho",
    name: "Chinese",
  },
  {
    id: "zul",
    char2Code: "zu",
    char3Code: "zul",
    name: "Zulu",
  },
] as const;
